import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id C8354F93-0DA4-48B4-97B3-4BDE2C0046AB
 * name alert-rhombus
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alert-rhombus.svg
 * tags
 * - Alert / Error 
 */
export const AlertRhombusIcon = createSvgIcon(<><path d="M12 2C11.5 2 11 2.19 10.59 2.59L2.59 10.59C1.8 11.37 1.8 12.63 2.59 13.41L10.59 21.41C11.37 22.2 12.63 22.2 13.41 21.41L21.41 13.41C22.2 12.63 22.2 11.37 21.41 10.59L13.41 2.59C13 2.19 12.5 2 12 2M11 7H13V13H11V7M11 15H13V17H11V15Z" /></>, 'AlertRhombusIcon');
export default AlertRhombusIcon